<template>
  <div id="openstreet-map" :class="'h-' + height">

    <l-map
      :zoom="zoom"
      :center="center"
      @click="addMarker"
      ref="mymap"
    >
      <l-tile-layer
          :url="url"
          :attribution="attribution"
      />

      <l-marker
        v-if="lat && long"
        :lat-lng="location"
      >
      </l-marker>

      <l-marker
          v-else-if="position"
          :lat-lng="position"
      >
      </l-marker>
    </l-map>
  </div>
</template>

<script>
// cannot use dynamic import here because dynamic routes
// returns a promise which cant be used in computed
// where method is needed
import {latLng, Icon} from 'leaflet';
import 'leaflet/dist/leaflet.css';

export default {
  name: "OpenStreetMap",
  components: {
    LMap: () => import('vue2-leaflet/src/components/LMap'),
    LTileLayer: () => import('vue2-leaflet/src/components/LTileLayer'),
    LMarker: () => import('vue2-leaflet/src/components/LMarker')
  },
  props: ['lat', 'long', 'height'], //if object has already lat long defined (edit)
  data() {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      position: null
    }
  },
  computed: {
    zoom() {
      if(this.lat && this.long){
        return 18;
      } else {
        return 7;
      }
    },
    center() {
      if(this.lat && this.long){
        return latLng(this.lat, this.long)
      } else {
        return latLng(47.515898, 14.126496) // coordinates of austria
      }
    },
    location() { // coordinates of already defined location
      return latLng(this.lat, this.long);
    }
  },
  methods: {
    addMarker(e) { // add marker to map
      this.position = e.latlng;
      this.$emit('changeLocation', e.latlng);
    },

    recenterMap(lat, long) {
      setTimeout(() => {
        if(this.$refs.mymap) {
          this.$refs.mymap.mapObject.panTo(latLng(lat, long));
        }
      }, 300);
    },

    refreshMap() {
      setTimeout(() => {
        if(this.$refs.mymap) {
          this.$refs.mymap.mapObject.invalidateSize(); // reload map with setted center and zoom
        }
      }, 100);
    }
  },
  updated() {
    if(this.lat && this.long) {
      this.refreshMap();
    }
  },
  mounted() {
    // set marker image for leaflet marker
    delete Icon.Default.prototype._getIconUrl;
    Icon.Default.mergeOptions({
      iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
      iconUrl: require('leaflet/dist/images/marker-icon.png'),
      shadowUrl: require('leaflet/dist/images/marker-shadow.png')
    })
  }
}
</script>
<style src="@/modules/core/components/OpenStreetMap/OpenStreetMap.scss" lang="scss"/>
